import { gql } from "graphql-request";
export const ALL_TAGS = gql`
    query allTags {
        allTags {
            slug
            name
        }
    }
`;
